import React from "react"
import { Button } from "./styled"

import { MagentaSection, LinkButton } from "./styled"
import { CrossCompanyPhoneCheck } from "./auth/CrossCompanyPhoneCheck"

export const CheckStatusComponent = (props) => {
  const initialValues = {
    phoneNumber: ""
  }

  const SubmitButton = ({disabled}) => (
    <Button type="submit" className="btn btn-primary2" disabled={disabled}>Check status</Button>
  )

  return (
    <section>
      <MagentaSection className="container-fluid py-5">
        <div className="row">
          <div className="container">
            <h1 className="text-center pb-3">Check your submission status</h1>
            {props.sprintRedirectActive ? <div className="row text-center">
              <div className="mx-auto col-md-4"></div>
              <div className="mx-auto col-md-4">
                <div>
                  <CrossCompanyPhoneCheck initialValues={initialValues} buttons={[SubmitButton]} checkStatusMode />
                </div>
              </div>
              <div className="mx-auto col-md-4"></div>
            </div>
              :
              <div className="text-center">
                <LinkButton href={process.env.REACT_APP_TMO_ID_AUTH_URL}>Check status</LinkButton>
              </div>
            }
          </div>
        </div>
      </MagentaSection>
    </section>
  )
}
